import type { RouteRecordRaw } from 'vue-router';

import { ROUTES } from '@/constants/routes';
import i18n from '@/i18n';

import type { BreadcrumbProps } from '@/dsComponents/breadcrumbs/types';

const routes: RouteRecordRaw[] = [
	{
		path: 'demande-acompte',
		name: ROUTES.APP.PAYMENT_REQUEST._ROOT,
		redirect: () => ({
			name: ROUTES.APP.PAYMENT_REQUEST.LIST,
		}),
		component: () =>
			import(/* webpackChunkName: "payment-request" */ './views/Layout.vue'),
		children: [
			{
				path: 'liste',
				name: ROUTES.APP.PAYMENT_REQUEST.LIST,
				component: () =>
					import(
						/* webpackChunkName: "payment-request" */ './views/PaymentRequestList.vue'
					),
				meta: {
					breadcrumbs: <BreadcrumbProps>{
						items: [
							{
								label: i18n.global.t('breadcrumbs.workers.paymentRequests'),
								icon: 'money',
							},
						],
					},
				},
			},
			{
				path: 'archives',
				name: ROUTES.APP.PAYMENT_REQUEST.ARCHIVE,
				component: () =>
					import(
						/* webpackChunkName: "payment-request" */ './views/PaymentRequestList.vue'
					),
				meta: {
					breadcrumbs: <BreadcrumbProps>{
						items: [
							{
								label: i18n.global.t('breadcrumbs.workers.paymentRequests'),
								icon: 'money',
							},
						],
					},
				},
			},
		],
	},
];

export default routes;
